import { render, staticRenderFns } from "./EditNomCateg.vue?vue&type=template&id=2e97a05f&scoped=true&"
import script from "./EditNomCateg.ts?vue&type=script&lang=ts&"
export * from "./EditNomCateg.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e97a05f",
  null
  
)

export default component.exports
import {QForm,QInput,QBtn} from 'quasar'
component.options.components = Object.assign({QForm,QInput,QBtn}, component.options.components || {})
